import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { updateNewReviewers } from "@api/preview/send"
import AvailabilityAndExpiryDates from "./availability_and_expiry_dates"

const DateRestrictions = ({ stateKey, newReviewers, updateNewReviewers }) => {
  return (
    <AvailabilityAndExpiryDates
      model={newReviewers}
      updateModel={(key, value) => updateNewReviewers(stateKey, key, value)}/>
  )
}

const mapStateToProps = (state, ownProps) => ({})

const mapDispatchToProps = dispatch => ({
  updateNewReviewers: bindActionCreators(updateNewReviewers, dispatch)
})

DateRestrictions.propTypes = {
  newReviewers: PropTypes.object.isRequired,
  expiry: PropTypes.string,
  available_at: PropTypes.string,
  updateNewReviewers: PropTypes.func.isRequired,
  stateKey: PropTypes.oneOf(["email", "link"]).isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(DateRestrictions)
